import React from 'react';
import { Logger } from 'aws-amplify';
import { NotificationBadge } from 'src/components/NotificationBadge';
import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';
import { FlagsContext } from '../../../../context';
import { useNotificationBadgeData } from 'src/hooks/useNotificationBadgeData';
import { useAppSelector } from 'src/hooks/useStore';

const logger = new Logger('ContractNotificationsBadge');

// FormsNotificationsBadge notifications for forms events
export const ContractNotificationsBadge = () => {
  const { EnableManyCompanies } = React.useContext(FlagsContext);
  const { backgroundColor, textColor } = useNotificationBadgeData(true); // isSidebar = true
  const activeCompanyId = useAppSelector(
    (state: RootState) => state.activeCompany.activeCompanyId,
  );

  const notifications = useAppSelector(
    (state: RootState) => state.notifications.esigRequestNotifications,
  );

  // Filter notifications by company if EnableManyCompanies is true
  const filteredNotifications = EnableManyCompanies
    ? notifications.filter((notif) => notif.companyId === activeCompanyId)
    : notifications;

  const [notificationsCounter, setNotificationsCounter] = React.useState(0);

  React.useEffect(() => {
    logger.debug('Setting primary contracts sidebar notification');
    // filter unread notification
    logger.debug('Total notifications:', filteredNotifications.length);
    const unreadNotifications = filteredNotifications.filter((notif) =>
      isUnreadNotification(notif.ownerId),
    );

    logger.debug('Unread notifications:', unreadNotifications.length);

    setNotificationsCounter(unreadNotifications.length);
  }, [filteredNotifications]);

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={notificationsCounter}
      backgroundColor={backgroundColor}
      textColor={textColor}
    />
  );
};
